import Label from "components/Label";
import { Stack } from "@material-ui/core";
import type { RealEstateContact } from "../../../../../@types/sharedSchema";

type ContactTablePropertyProps = {
  contact: Partial<RealEstateContact>;
};

export function ContactTableTag({ contact }: ContactTablePropertyProps): JSX.Element {
  const tagsArray = contact.tags;

  if (!tagsArray?.length) return null;

  return (
    <Stack direction="row" gap={1} flexWrap="wrap">
      {tagsArray.map((tag, index) => (
        <Label key={index}>{tag}</Label>
      ))}
    </Stack>
  );
}
